module.exports = "<div class=\"catalog-view\"><sc-catalog-view-node ng-repeat=\"filter in $ctrl.filter.children\" model=\"$ctrl.model\" filter=\"filter\" filter-bar=\"$ctrl.filterBar\"></sc-catalog-view-node></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/catalog/catalog-view.component.html
// module id = 386
// module chunks = 0